module.exports = __webpack_public_path__ + "img/home2-jp.eb3fc7bf.png";